<template>
  <div class="failureAccess">
    <i class="iconfont icon-shibai-icon topicon"></i>
    <p class="title">{{tip}}</p>
    <div class="sepLineShell">
      <p class="sepLine"></p>
    </div>
    <div class="orderInfo">
      <div class="shell">
        <p class="list">
          <span class="fl">评估结果</span><span class="fr "><span
              class="seeDetail"
              @click="seeReason"
            >查看详情<i :class="{'iconfont icon-shang':this.seeResult===false,'iconfont icon-xia':this.seeResult===true}"></i></span></span>
        </p>
      </div>
      <div
        class="reason"
        v-if="this.seeResult===true"
      >
        <p
          v-for="(item,index) in this.$store.state.commonForms.modalErrorReason.split('@')"
          :key="index"
        >
          {{index-0+1}}. {{item}}
        </p>
      </div>
      <div class="shell">
        <p class="list" v-if="productCategory !== '1'">
          <span class="fl">企业名称</span><span class="fr ">{{ this.$store.state.commonForms.corpName }}</span>
        </p>
        <p class="list">
          <span class="fl">借款人</span><span class="fr ">{{ this.$store.state.commonForms.borrowerName }}</span>

        </p>
        <p class="list">
          <span class="fl">申请产品</span><span class="fr ">{{ this.$store.state.commonForms.productName}}</span>
        </p>
        <p class="list">
          <span class="fl">申请时间</span><span class="fr ">{{ this.$store.state.commonForms.orderTime}}</span>
        </p>

      </div>
    </div>

    <div
      class="reapply"
      v-if="isShowButton&&($route.query.productId!=='WC-HFQ'&&$route.query.productId!=='BSD-XYKD')"
      @click="gotoPerfect"
      :disabled="!this.$store.state.commonForms.canRetry"
    >
      重新申请
    </div>

    <div class="buttonShell">
      <van-button
        :text="back"
        :type="danger"
        :plain="plain"
        class="goBack"
        @click="gotoHome"
        size="large"
        v-if="isShowButton"
        :style="{ marginRight: flag === 1 ? '8px' : '0px' }"
      />
      <van-button
        v-if="flag === 1"
        text="查看数据情况"
        :type="danger"
        class="retry"
        size="large"
        @click="onDetails"
      />
    </div>

  </div>
</template>}

<script>
import API from '@/request/api';
import { checkStatus } from './mixin';
//  orderId: localStorage.getItem('orderId'), //  订单号

export default {
  name: 'WaitingEvaluate',
  data() {
    return {
      isLoading: false,
      back: '返回首页',
      danger: 'danger',
      plain: 'plain',
      tip: '初审失败',
      statusCode: '',
      seeResult: false,
      isShowButton: false,
      flag: 0,
      productCategory: '',
    };
  },
  mixins: [checkStatus],
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background-color:#fff!important');
  },
  created() {
    this.statusCode = this.$route.query.status;
  },
  mounted() {
    if (this.$route.query.status === '' || this.$route.query.status === undefined || this.$route.query.status === null) {
      this.$store.dispatch('commonForms/checkCurrentStatus', true);
    } else {
      const temp = this.statusCode.slice(0, 5);
      if (temp === '20003') {
        this.tip = '评估失败';
        document.title = '评估失败';
      }
      if (temp === '40002') {
        this.tip = '授信失败';
        document.title = '授信失败';
      }
      this.$store.dispatch('commonForms/checkCurrentStatus', true);
    }
    this.getOrderType();
    this.queryButtonIsShow();
    this.getProductCategory()
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },

  methods: {
    getProductCategory(){
      this.$api.PublicPage.getProductDetail([this.$route.query.productId]).then((res) => {
        if (res.success) {
          this.productCategory = res.data[0].productCategory
        }
      });
    },
    onDetails() {
      const { orderId, productId, statusCode } = this.$route.query;
      this.$router.push({
        path: '/supermarket/v2/dataAcquisition',
        query: {
          statusCode: 2,
          redirect: encodeURIComponent(`/supermarket/v2/FailureAccess?orderId=${orderId}&productId=${productId}&statusCode=${statusCode}`),
          orderId,
          productId,
        },
      });
    },
    async queryButtonIsShow() {
      const res = await this.$api.PublicPage.isDataAcquisition({
        orderId: this.$route.query.orderId,
        productId: this.$route.query.productId,
      });
      console.log(res, '==res');
      if (res.returnCode === '200' && res.data.type) {
        this.flag = 1;
      } else {
        this.flag = 2;
      }
    },
    seeReason() {
      this.seeResult = !this.seeResult;
    },
    gotoPerfect() {
      this.$store.dispatch('commonForms/resetOrder');
    },
    gotoHome() {
      window.location.href = '/supermarket/v2/';
    },
    getOrderType() {
      const orderId = localStorage.getItem('orderId') || this.$route.query.orderId;
      API.PublicPage.getOrderType({
        orderId,
        productId: this.$route.query.productId,
      }).then((res) => {
        if (!(res.success && res.data && res.data.orderType === '1')) {
          this.isShowButton = true;
        }
      });
    },
  },
};
</script>
<style scoped>
.reapply {
  height: 44px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #ff6538;
  text-align: right;
  line-height: 44px;
  font-weight: 400;
  text-align: center;
  width: 80px;
  margin: 0 auto;
}
.reason {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 15px;
  color: #7c7c7c;
  font-size: 12px;
  text-align: left;
  background: #f8f9fb;
}
.title {
  color: #1c2438;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
}

.sepLineShell {
  box-sizing: border-box;
  width: 100%;
  margin-top: 40px;
  padding-right: 15px;
  padding-left: 15px;
}
.sepLine {
  width: 100%;
  height: 1px;
  background: #dfdede;
}
.buttonShell {
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding-right: 15px;
  padding-left: 15px;
  display: flex;
  margin-top: 30px;
}
.retry {
  flex: 1;
  margin-left: 8px;
  background: #ff6538;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  font-weight: 600;
}
.goBack {
  flex: 1;
  background: #ffffff;
  border: 1px solid #bcc2cc;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #2f3133;
  text-align: center;
  font-weight: 400;
}
.grey {
  background-color: grey;
}
.shell {
  box-sizing: border-box;
  width: 100%;
  padding-top: 15px;
  padding-right: 15px;
  padding-left: 15px;
}
.list {
  height: 44px;
  margin: 0;
  padding: 0;
  color: #495060;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
}
.fl {
  float: left;
  line-height: 22px;
}
.fr {
  float: right;
  width: 70%;
  line-height: 22px;
  text-align: right;
}
.topicon {
  display: block;
  padding-top: 103px;
  color: #f65249;
  font-size: 60px;
}
.seeDetail {
  color: #f55646;
}
</style>
